import { useState } from 'react';
import './Folder.css';

const darkenColor = (color, percent) => {
  if (color.startsWith('hsl')) {
    const m = color.match(/hsl\(([^,]+),\s*([\d.]+)%,\s*([\d.]+)%\)/);
    if (m) return `hsl(${m[1]}, ${m[2]}%, ${Math.max(0, parseFloat(m[3]) - percent * 100)}%)`;
  }
  let hex = color.startsWith('#') ? color.slice(1) : color;
  if (hex.length === 3) hex = hex.split('').map(c => c + c).join('');
  const num = parseInt(hex, 16);
  const r = Math.max(0, Math.min(255, Math.floor(((num >> 16) & 0xff) * (1 - percent))));
  const g = Math.max(0, Math.min(255, Math.floor(((num >> 8)  & 0xff) * (1 - percent))));
  const b = Math.max(0, Math.min(255, Math.floor(( num        & 0xff) * (1 - percent))));
  return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase();
};

export default function Folder({ color = '#635bff', size = 1, items = [], className = '', onOpen, isOpen }) {
  const maxItems = 3;
  const papers = [...items.slice(0, maxItems)];
  while (papers.length < maxItems) papers.push(null);

  const [localOpen, setLocalOpen] = useState(false);
  const open = isOpen || localOpen;
  const [offsets, setOffsets] = useState(Array.from({ length: maxItems }, () => ({ x: 0, y: 0 })));

  const handleClick = (e) => {
    e.stopPropagation();
    if (onOpen) {
      // briefly pop open for the dopamine hit, then let the modal take over
      setLocalOpen(true);
      setTimeout(() => setLocalOpen(false), 650);
      onOpen();
    } else {
      setLocalOpen(v => !v);
    }
  };

  const handleMove = (e, i) => {
    if (!open) return;
    const r = e.currentTarget.getBoundingClientRect();
    setOffsets(prev => {
      const n = [...prev];
      n[i] = {
        x: (e.clientX - r.left - r.width  / 2) * 0.15,
        y: (e.clientY - r.top  - r.height / 2) * 0.15,
      };
      return n;
    });
  };

  const handleLeave = (i) => {
    setOffsets(prev => { const n = [...prev]; n[i] = { x: 0, y: 0 }; return n; });
  };

  return (
    <div style={{ transform: `scale(${size})` }} className={className}>
      <div
        className={`folder${open ? ' open' : ''}`}
        style={{
          '--folder-color':      color,
          '--folder-back-color': darkenColor(color, 0.08),
          '--paper-1':           'var(--surface2)',
          '--paper-2':           'var(--surface)',
          '--paper-3':           'var(--surface)',
        }}
        onClick={handleClick}
      >
        <div className="folder__back">
          {papers.map((item, i) => (
            <div
              key={i}
              className={`paper paper-${i + 1}`}
              onMouseMove={e => handleMove(e, i)}
              onMouseLeave={() => handleLeave(i)}
              style={open ? { '--magnet-x': `${offsets[i].x}px`, '--magnet-y': `${offsets[i].y}px` } : {}}
            >
              {item}
            </div>
          ))}
          <div className="folder__front" />
          <div className="folder__front right" />
        </div>
      </div>
    </div>
  );
}
